import { computed } from "vue";
import type { LOSType } from "@/models/opal";
import type { Option } from "@/models/form";
import store from "@/store";

export default function useAddressFormData() {
  const addressUnitTypes = computed<LOSType[]>(() => store.state.lookupsModule.addressUnitTypes);
  const countryOptions = computed<Option[]>(() => store.getters["lookupsModule/countryOptions"]);
  const statesOptions = computed<Option[]>(() => store.getters["lookupsModule/statesOptions"]);
  const unitTypeOptions = computed<Option[]>(
    () => store.getters["lookupsModule/addressUnitsOptions"],
  );

  return {
    addressUnitTypes,
    countryOptions,
    statesOptions,
    unitTypeOptions,
  };
}
